package com.appsyde.shared.modules.ticket.domain.usecase

import com.appsyde.shared.modules.ticket.domain.repository.TicketsRepository

class AddMemoryUseCase(private val repo: TicketsRepository) {
    suspend operator fun invoke(ticketId: String, key: String, value: String) {
        repo.addMemory(ticketId = ticketId, key = key, value = value)
    }
}
